import React from 'react';
import CustomContainer from '../../components/CustomContainer';
import LegalDocumentViewer from './LegalDocumentViewer';

const ActualLegalDocumentPage = () => {

  return (
    <LegalDocumentViewer container={CustomContainer} />
  );
};

export default ActualLegalDocumentPage;
